// Sub-aba "Cardápio de produtos" (Banners → Totem): até 5 imagens largas que
// passam no topo do cardápio do totem. Mesmo upload/recorte 3,5:1 do banner
// do cardápio (uma arte serve nos dois). Pedido do dono (10/09/2026).
import BannerCard from "./components/BannerCard";
import BannersCarregando from "./components/BannersCarregando";
import BannerUploader from "./components/BannerUploader";
import { useBanners } from "./hooks/useBanners";

export default function TotemBannersCardapioTab() {
  const { banners, loading, enviando, maximo, adicionar, alternarAtivo, remover, mover } = useBanners("totem_cardapio");
  const noAr = banners.filter((b) => b.enabled).length;

  return (
    <div className="space-y-6" data-e2e="painel-totem-banners-cardapio">
      <p className="text-xs text-muted-foreground -mt-2">
        {banners.length === 0
          ? `Até ${maximo} imagens largas no topo do cardápio do totem.`
          : `${noAr} no ar de ${banners.length} cadastrada${banners.length === 1 ? "" : "s"} · máximo ${maximo}`}
      </p>
      <BannerUploader onArquivo={adicionar} enviando={enviando} desabilitado={banners.length >= maximo} />
      {loading ? (
        <BannersCarregando />
      ) : banners.length === 0 ? (
        <div className="bg-card border border-border rounded-2xl p-8 text-center text-sm text-muted-foreground">
          Nenhum banner no cardápio do totem. Eles aparecem numa faixa larga acima dos produtos e trocam a cada 5 segundos.
        </div>
      ) : (
        <div className="space-y-3">
          {noAr > 1 && <p className="text-xs text-muted-foreground">Com mais de um no ar, o totem troca de banner a cada 5 segundos nesta ordem.</p>}
          {banners.map((banner, i) => (
            <BannerCard key={banner.id} banner={banner} posicao={i} total={banners.length} onToggle={alternarAtivo} onRemover={remover} onMover={mover} />
          ))}
        </div>
      )}
    </div>
  );
}
